import { render, staticRenderFns } from "./LanguageAndTimezone.vue?vue&type=template&id=00cfead3&"
import script from "./LanguageAndTimezone.vue?vue&type=script&lang=js&"
export * from "./LanguageAndTimezone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports